import { createAction } from '@reduxjs/toolkit';

export const UPDATE_GREETING_ACTION_TYPE = 'saga/updateGreeting';
export const updateGreetingAction = createAction(UPDATE_GREETING_ACTION_TYPE);
